// HELPERS
import { useMakeRequest } from '@/hooks'

// CONSTANTS
import { routes } from '../../constants'

// TYPES
import { ProfileStatisticsResponse } from './types'

/**
 * Gets profile statistics of the current user
 */
export function useProfileStatistics() {
  return useMakeRequest<ProfileStatisticsResponse>(
    routes.PROFILE_STATISTICS_API,
  )
}
